<template>
  <div class="permissionIntro">
    <div class="top">
        <div class="page-title top0">功能权限</div>
    </div>
    <div class="tableBox">
      <el-table :data="permissionList" v-loading="tableLoading" border stripe style="width: 100%">
        <el-table-column
          prop="moduleName"
          label="权限名称">
        </el-table-column>
        <el-table-column
          prop="authorityNameList"
          label="功能板块">
          <template slot-scope="scope">
            <div class="content">
              <p v-for="(item,index) in scope.row.authorityNameList" :key="index">{{item}}</p>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="creationDate"
          label="创建日期">
        </el-table-column>
        <el-table-column
          prop="modifiedDate"
          label="修改日期">
        </el-table-column> -->
      </el-table>
    </div>
  </div>
</template>
<script>

export default {
  name: 'permissionIntro',
  data () {
    return {
      tableLoading: false,
      permissionList: []
    }
  },
  created () {
  },
  mounted () {
    this.getPermissionList()
  },
  watch: {
  },
  methods: {
    getPermissionList () {
      this.tableLoading = true
      this.$service.post('/api/role/authorityModule/details', {}).then(res => {
        console.log(res)
        this.permissionList = res.result
        //  [{
        //   name: 'A（基础权限）',
        //   content: ['1.首页', '2.账户管理', '3. 投放-投放管理', '4.报表-广告报表', '5.监控-操作日志/巨量日志'],
        //   creationDate: '2020-09-09',
        //   modifiedDate: '2020-09-12'
        // }, {
        //   name: 'B（投放权限）',
        //   content: ['1.投放（除投放管理外全部模块）', '2.素材（素材库+标题库+屏蔽词库）'],
        //   creationDate: '2020-09-09',
        //   modifiedDate: '2020-09-12'
        // }, {
        //   name: 'C（报表权限）',
        //   content: ['1.报表（除广告报表外全部模块）'],
        //   creationDate: '2020-09-09',
        //   modifiedDate: '2020-09-12'
        // }, {
        //   name: 'D（监控权限）',
        //   content: ['1.监控（除操作日志和巨量日志外全部模块）'],
        //   creationDate: '2020-09-09',
        //   modifiedDate: '2020-09-12'
        // }]
        this.tableLoading = false
      }).catch(Err => {
        console.log(Err)
      })
    }
  }
}
</script>

<style lang="less">
  @import './../../styles/operationManage/permissionIntro.less';
</style>



// WEBPACK FOOTER //
// src/views/operationManage/permissionIntro.vue